'use client'

import { cn } from '@/lib/utils'

import {
  EASE,
  HAIRLINE,
  SectionHead,
  restoreDashes,
  useReveal,
} from '@/components/page-kit'
import { ACCOUNTS } from './data'

/* The four authored benefits as full-width ruled rows — the inverse of this
   page's features, which are quadrants. (HRMS and Payroll do it the other way
   round: rows for features, quadrants for benefits.)

   Heading is a verbatim fragment of `longDescription`, capitalised to open a
   sentence. */

export function AccountsBenefits() {
  const list = useReveal<HTMLDivElement>(0.1)

  return (
    <section className="pt-16 sm:pt-20 md:pt-28">
      <div className="container mx-auto">
        <SectionHead
          eyebrow="Why Accounts"
          title="Replacing fragmented tools and manual reconciliations."
        />

        <div ref={list.ref} className={cn('mt-10 border-t sm:mt-12', HAIRLINE)}>
          {ACCOUNTS.benefits.map((b, i) => (
            <div
              key={b.title}
              className={cn(
                'grid grid-cols-1 gap-x-10 gap-y-2 border-b py-6 sm:py-7',
                'lg:grid-cols-[minmax(0,340px)_1fr] lg:items-baseline',
                HAIRLINE
              )}
              style={{
                opacity: list.shown ? 1 : 0,
                transform: list.shown ? 'none' : 'translateY(10px)',
                transition: `opacity 500ms ${EASE} ${i * 90}ms, transform 500ms ${EASE} ${i * 90}ms`,
              }}
            >
              <div className="flex items-baseline gap-4">
                <span className="w-6 shrink-0 text-[11px] tabular-nums text-muted-foreground/60">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h3 className="font-heading text-lg font-normal leading-snug text-foreground sm:text-xl">
                  {b.title}
                </h3>
              </div>

              <p className="pl-10 text-sm leading-relaxed text-muted-foreground sm:text-base lg:pl-0">
                {restoreDashes(b.description)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
